// @flow
import React from "react";
import CountUp from "react-countup";
import StarRating from "../../common/starRating/StarsIconRating";
import I18n from "../../../i18n/I18n";
import Helper from "../../../helper/Helper";
import styles from "./DashboardSummary.scss";

const DashboardSummary = (props: Object) => {
  const info = props.info || "";
  return (
    <div className={styles.summaryCtr}>
      <div className={styles.summaryItem}>
        <h6 className={styles.summaryTitle}>
          {I18n.getText(
            "dashboard.revenue-summary",
            { currency: I18n.formatCurrency({ currency: props.currencyCode }) },
            "Total Paid Revenue ({currency})"
          )}
        </h6>
        {info ? (
          <div className={styles.summaryContent}>
            {I18n.formatCurrency(
              Helper.formatPrice(info.revenue, props.currencyCode)
            )}
          </div>
        ) : (
          ""
        )}
      </div>
      <div className={styles.summaryItem}>
        <h6 className={styles.summaryTitle}>
          {I18n.getText("dashboard.orders-summary", {}, "Total orders")}
        </h6>
        {info ? (
          <div className={styles.summaryContent}>
            <CountUp start={0} end={Number(info.total_orders)} />
          </div>
        ) : (
          ""
        )}
      </div>
      <div className={styles.summaryItem}>
        <h6 className={styles.summaryTitle}>
          {I18n.getText("dashboard.offers-summary", {}, "live")}
        </h6>
        <div className={styles.summaryContent}>
          <CountUp start={0} end={Number(info ? info.live_offers : 0)} />
        </div>
      </div>
      <div className={styles.summaryItem}>
        <h6 className={styles.summaryTitle}>
          {I18n.getText("dashboard.rating-summary", {}, "")}
        </h6>
        <div className={`${styles.summaryContent} ${styles.rating}`}>
          {info ? info.store_score : ""}
          <div className={styles.ratingCtr}>
            <StarRating
              score={info ? info.store_score : ""}
              maxScore={5}
              size={10}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

DashboardSummary.propTypes = {};

DashboardSummary.getDefaultProps = {};

export default DashboardSummary;



// WEBPACK FOOTER //
// ./src/components/dashboard/dashboardSummary/DashboardSummary.js